import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  Alert,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography
} from '@mui/material';
import rootApi from '@utils/baseAPI/WrapperApi';
import { showError, showSuccess } from '@components/notification';
import { apiSetCustomerFundedPartner } from '@services/customer.service';

// Khách hàng đặc biệt: tài khoản do chủ trạm nạp tiền ảo. Chỉ sạc được ở trạm của chủ trạm đó,
// không nạp tiền trực tuyến / rút / chuyển số dư, phiên sạc không xuất hoá đơn và không thu hộ khi đối soát.
const FundedPartnerCard = ({ customer, refetch }) => {
  const [partnerId, setPartnerId] = useState('');
  const [saving, setSaving] = useState(false);

  const { data: partners } = useQuery(['admin-get-all-partners'], () =>
    rootApi.get('/admin/partners/search?page=0&size=100')
  );
  const partnerList = partners?.data?.data || [];

  useEffect(() => {
    setPartnerId(customer?.funded_partner_id ? String(customer.funded_partner_id) : '');
  }, [customer?.funded_partner_id]);

  const current = customer?.funded_partner_id ? String(customer.funded_partner_id) : '';

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await apiSetCustomerFundedPartner(customer?.id, {
        partner_id: partnerId ? Number(partnerId) : null
      });
      if (res?.data?.status?.code === 'success') {
        showSuccess({ message: 'Cập nhật khách hàng đặc biệt thành công' });
        if (refetch) refetch();
      } else {
        showError({ message: res?.data?.message || 'Cập nhật thất bại' });
      }
    } catch (error) {
      showError({ message: error?.response?.data?.message || 'Cập nhật thất bại' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ border: '1px solid #E4E4E7', borderRadius: 2, p: 2, mb: 2 }}>
      <Typography sx={{ fontWeight: 600, mb: 1 }}>Khách hàng đặc biệt của chủ trạm</Typography>
      <Stack direction={{ md: 'row', xs: 'column' }} spacing={2} alignItems="center">
        <FormControl size="small" sx={{ minWidth: 320 }}>
          <InputLabel>Chủ trạm nạp tiền ảo</InputLabel>
          <Select
            value={partnerId}
            label="Chủ trạm nạp tiền ảo"
            onChange={(e) => setPartnerId(e.target.value)}
          >
            <MenuItem value="">Không phải khách hàng đặc biệt</MenuItem>
            {partnerList.map((p) => (
              <MenuItem key={p.id} value={String(p.id)}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          variant="contained"
          disabled={saving || partnerId === current}
          onClick={handleSave}
          sx={{ bgcolor: '#2D9764', '&:hover': { bgcolor: '#2D9764' } }}
        >
          Lưu
        </Button>
      </Stack>
      {partnerId && (
        <Alert severity="info" sx={{ mt: 2 }}>
          Chỉ sạc được tại trạm của chủ trạm này; không nạp tiền trực tuyến, rút tiền hay chuyển số
          dư. Phiên sạc không xuất hoá đơn, vẫn tính phí dịch vụ nhưng không trả tiền thu hộ cho chủ
          trạm khi đối soát.
        </Alert>
      )}
      {partnerId !== current && (
        <Alert severity="warning" sx={{ mt: 1 }}>
          Chỉ áp dụng cho phiên sạc trả tiền sau khi lưu; số dư ví hiện tại (
          {(customer?.wallet_response?.amount ?? 0).toLocaleString('vi-VN')}₫) giữ nguyên.
        </Alert>
      )}
    </Box>
  );
};

export default FundedPartnerCard;
